import { capitalizeString, DateFormats, formatDate } from '@strata/helper-functions';
import { GridWithSearch, SecondaryData } from '@strata/react-grid';
import { InlineMessage } from '@strata/react-inline-message';
import { HomeScreen } from '@strata/react-page-templates';
import { useNavigate } from 'react-router';

import { ListPageHeader } from 'components/ListPageHeader';
import {
    ApplicationDisplayTextMap,
    formatDisplayColText,
} from 'pages/homeScreenMessaging/HomeScreenHelpers';
import { CREATE_ROUTE } from 'services/constants';
import { useGet } from 'services/Http';

const columns = [
    {
        header: 'Created Date/Time',
        accessorKey: 'publish_date',
        size: 155,
        cell: ({ getValue }) => (
            <SecondaryData data={formatDate(getValue(), DateFormats.DATE_TIME)} />
        ),
    },
    { header: 'Message Type', accessorKey: 'message_category', size: 150 },
    { header: 'Message', accessorKey: 'message', size: 275 },
    {
        header: 'Intent',
        accessorKey: 'intent',
        size: 110,
        cell: ({ getValue }) => (
            <SecondaryData
                data={<InlineMessage intent={getValue()} label={capitalizeString(getValue())} />}
            />
        ),
    },
    {
        header: 'Applications',
        accessorKey: 'application',
        size: 160,
        cell: ({ getValue }) => <SecondaryData data={ApplicationDisplayTextMap[getValue()]} />,
    },
    {
        header: 'Display',
        accessorKey: 'display',
        size: 80,
        cell: ({ getValue }) => <SecondaryData data={formatDisplayColText(getValue())} />,
    },
    { header: 'Created By', accessorKey: 'created_by', size: 190 },
    { header: 'Last Modified By', accessorKey: 'last_modified_by', size: 190 },
];

export const UrgentMessageList = () => {
    const navigate = useNavigate();

    const messages = useGet(
        `/announcement/admin/home_screen/message/type/${HomeScreen.MessageType.URGENT}`,
    );

    return (
        <div className="sds_main-content__container">
            <ListPageHeader
                pageTitle="Urgent Messages"
                buttons={[
                    {
                        label: 'Create Urgent Message',
                        path: `/home-screen-messaging/urgent-messages/${CREATE_ROUTE}`,
                    },
                ]}
            />
            <div className="sds_main-content__grid">
                <GridWithSearch
                    data={messages}
                    isLoading={!messages}
                    columns={columns}
                    sortProperties={[{ id: 'publish_date', desc: true }]}
                    onRowClick={(row) =>
                        navigate(`/home-screen-messaging/urgent-messages/${row.message_id}`)
                    }
                />
            </div>
        </div>
    );
};
